import { cn } from "@/lib/utils";

interface KbdProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Static keyboard-shortcut chip used in search hints and filter toolbars.
 * Mirrors `.kbd` from mockup--opportunity-list.css:106-118.
 */
export function Kbd({ children, className }: KbdProps) {
  return (
    <kbd
      className={cn(
        "inline-flex items-center gap-[2px] px-2 py-[2px]",
        "rounded-[var(--radius-sm)] border border-[color:var(--color-border)]",
        "bg-[color:var(--color-surface)] text-[color:var(--color-text-md)]",
        "font-[family-name:var(--font-family-mono)] typo-label normal-case tracking-normal",
        className,
      )}
    >
      {children}
    </kbd>
  );
}
